import { Toggle } from '../toggle';

import { Label } from '../label';
import { getFieldError } from './get-field-error';
import { useFieldContext } from './form';

interface FormToggleProps extends Omit<
  React.ComponentProps<typeof Toggle>,
  'pressed' | 'onPressedChange'
> {
  label?: string;
  showErrorMessage?: boolean;
}

function FormToggle({ label, showErrorMessage = true, children, ...props }: FormToggleProps) {
  const field = useFieldContext<boolean>();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Toggle
          id={field.name}
          pressed={field.state.value ?? false}
          onPressedChange={(pressed) => field.handleChange(pressed)}
          {...props}
        >
          {children}
        </Toggle>
        {label ? (
          <Label htmlFor={field.name} className="cursor-pointer">
            {label}
          </Label>
        ) : null}
      </div>
      {showErrorMessage && field.state.meta.errors.length > 0 ? (
        <span className="text-destructive text-sm">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      ) : null}
    </div>
  );
}

export { FormToggle };
